export const enum UserPermissions {
  AccountsAdmit = "accounts:admit",
  AccountsManage = "accounts:manage",
  AccountsChangeCardOnFile = "accounts:change-card-on-file",
  AccountBillingManagement = "accounts:billing-management",
  AccountBillingHistory = "accounts:billing-history",
  AccountAttendanceHistory = "accounts:attendance",
  AccountsViewPurchasedItems = "accounts:view-purchased-items",
  AccountNotesRead = "account-notes:read",
  AccountNotesCreate = "account-notes:create",
  AccountVoidRefundTransaction = "accounts:void-refund-transaction",
  AttractionsManage = "attractions:manage",
  AttractionsAdmin = "attractions:admin",
  AttractionTypesManage = "attraction-types:manage",
  BookingViewModule = "booking:view-module",
  BookingViewEventScreen = "booking:view-event-screen",
  BookingCancelParty = "booking:cancel-party",
  BookingFinalizeNoShow = "booking:finalize-no-show",
  BookingFinalizeNoShowChargeCard = "booking:finalize-no-show-charge-card",
  BanPerson = "accounts:ban-person",
  CrowdMeterManage = "crowd-meter:manage",
  DashboardView = "dashboard:view",
  DashboardHourlyMetrics = "dashboard:hourly-metrics",
  DocumentsManage = "documents:manage",
  LocationsAdmin = "locations:admin",
  LocationsManage = "locations:manage",
  LocationsMigrateMemberships = "locations:migrate-memberships",
  LocationsMigrateSchedules = "locations:migrate-schedules",
  LocationsRenewWaivers = "locations:renew-waivers",
  MakeupsManage = "makeups:manage",
  ProductsManage = "products:manage",
  ProductsView = "products:view",
  ProductsAdmin = "products:admin",
  ProductsBulkCreate = "products:bulk-create",
  PromotionsManage = "promotions:manage",
  PromotionsAdmin = "promotions:admin",
  PromotionsApply = "promotions:apply",
  ReportsReservationEnrollment = "reports:reservation-enrollment",
  ReportsOperationsBooking = "reports:operations-booking",
  ReportsOperationsMigration = "reports:operations-migration",
  ReportsCorporateMigration = "reports:corporate-migration",
  ReportsCorporateSales = "reports:corporate-sales",
  ReportsCorporateDataFlow = "reports:corporate-data-flow",
  ReportsCorporateDataFlowLeadership = "reports:corporate-data-flow-leadership",
  ReportsRevenueReconciliation = "reports:revenue-reconciliation",
  ReportsOperationsSales = "reports:operations-sales",
  ReportsSales = "reports:sales",
  ReportsTax = "reports:tax",
  ReportsAccounting = "reports:accounting",
  ReportsDunning = "reports:dunning",
  ReportsAccountingReconciliation = "reports:accounting-reconciliation",
  ReportsAccountingProfitLoss = "reports:accounting-profit-loss",
  ReportsAccountingTax = "reports:accounting-tax",
  ReportsCorporateSystem = "reports:corporate-system",
  ReportsCalculatedSalesTax = "reports:calculated-sales-tax",
  ReportsFranchiseeChargeback = "reports:franchisee-chargeback",
  ReportsGiftCard = "reports:gift-card",
  ReportsRevenueSummary = "reports:revenue-summary",
  ReportsJustifiChargeback = "reports:justifi-chargeback",
  ReportsJustifiChargebackAction = "reports:justifi-chargeback-action",
  ReportsAchievements = "reports:achievements",
  ReportsCashDrawerLogs = "reports:cash-drawer-log",
  RolesAdmin = "roles:admin",
  UsersManage = "users:manage",
  UsersAdmin = "users:admin",
  UsersAssign = "users:assign",
  UsersPin = "users:pin",
  NotImplemented = "not:implemented",
  QueuesAdmin = "queues:admin",
  PendingRefundsManage = "pending-refunds:manage",
  CorporateJustiFiPaymentLookup = "corporate:justifipaymentlookup",
  ReleasesAdmin = "releases:admin",
  PaymentProvidersView = "payment-providers:view",
  SubscriptionsManage = "subscriptions:manage",
  SubscriptionsCancel = "subscriptions:cancel",
  SubscriptionsPause = "subscriptions:pause",
  SubscriptionsManageJustiFi = "subscriptions:manage-justifi",
  DunningRetryPayment = "dunning:retry-payment",
  RetentionDiscountsAdmin = "retention-discounts:admin",
  RetentionDiscountsApply = "retention-discounts:apply",
  Wingman = "wingman",
  PosUser = "pos:user",
  PosConfigurations = "pos:configurations",
  PosBookingChargeCardOnFile= "pos:booking-charge-card-on-file",
  PosManagerSkipWaiver = "pos:manager-skip-waiver",
  WingmanChatUI = "wingman:chat-ui",
  WingmanSourceAdmin = "wingman:source-admin",
  PosCardReaderProvision = "pos:card-reader-provision",
  PosConfetti = "pos:confetti",
  SchedulingEventTemplates = "scheduling:event-templates",
  AccountsIdentifyInstitutional = "accounts:identify-institutional",
  AccountsMediaOptOut = "accounts:media-opt-out",
  SellVariablePriceItems = "pos:sell-variable-price-items",
  SellMembershipsPOS2 = "pos:sell-memberships-pos-2.0",
  ReportsAchievementsAssignement = "reports:achievements-assignment",
  ReportsClassCheckIn = "reports:class-checkin",
  BrandSettingsEdit = "brand-settings:edit",
  PromoCardsManage = "promo-cards:manage",
  RateChangeView = "rate-change:view",
  RateChangeSubmit = "rate-change:submit",
  RateChangeApprove = "rate-change:approve",
  AppLauncher = "app-launcher",
  AppLauncherAdmin = "app-launcher:admin",
}
